function saveConfiguration() {
    return expivi.saveConfiguration(512, 512, null, null, { include_keys: true });
}

function createVariant(savedBundle) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: 'POST',
            url: '/apps/configurator',
            data: JSON.stringify({
                configuration: savedBundle.configured_products,
                productId: shopifyProductId
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(function(createResult) {
            createResult.configuredProduct = savedBundle.configured_products[0];
            resolve(createResult);
        }).fail(reject);
    });
}

function fixLinkAttributes(createResult) {
    var matchParameters = /(.*)\s(?:@scale:)(.*)(?:;).*(?:@rotation:)(.*)(?:;)/i;
    var optionKeys = Object.keys(createResult.options);
    optionKeys.forEach(function(key) {
        var value = createResult.options[key];
        if (!/.*(@scale).*(@rotation)/.test(value)) {
            return;
        }

        var matches = value.match(matchParameters);
        matchParameters.lastIndex = 0;
        if (matches.length === 4) {
            createResult.options[key] = matches[1];
            createResult.options['_' + key + '_rotation'] = matches[3];
            createResult.options['_' + key + '_scale'] = matches[2];
        }
    });
    return createResult;
}

function getPrintReadyFile(data) {
    return new Promise(function (resolve) {
        const configuredProduct = data.configuredProduct;
        const designAttribute = configuredProduct.attributes.find(function (attr) {
            return attr.attribute_value &&
                Number.isInteger(attr.attribute_value.media_id) &&
                attr.attribute_value.svg_element;
        });

        if (!designAttribute) {
            return resolve(data);
        }

        const genderAttribute = configuredProduct.attributes.find(function (attr) {
            return attr.attribute_key === 'gender';
        })

        if (!genderAttribute) {
            return resolve(data);
        }

        const sizeAttribute = configuredProduct.attributes.find(function (attr) {
            return attr.attribute_key === 'size';
        })

        if (!sizeAttribute) {
            return resolve(data);
        }

        const gender = genderAttribute.attribute_value_key === 'mens' ? 'm' : 'w';
        const size = sizeAttribute.attribute_value_key.replace('size_', '');
        const sizeKey = gender+size;

        requestPrintReadyFile(data, designAttribute.attribute_value.media_id, sizeKey)
            .then(function (filePath) {
                data.options['_print_ready_file'] = filePath;

                resolve(data);
            });
    });
}

function requestPrintReadyFile(data, mediaId, sizeKey) {
    return new Promise(function (resolve, reject) {


        $.ajax({
            url: '/apps/configurator',
            type: 'POST',
            data: JSON.stringify({
                svg_convert: true,
                configuration: {
                    catalogue_id: data.configuredProduct.catalogue_id,
                    attributes: data.configuredProduct.configuration.attributes
                },
                media_id: mediaId,
                format: 'pdf',
                dpi: data.dpi,
                hide_printmarks: false,
                hide_placeholders: true,
                cmyk: false,
                masks: ExpiviMasks,
                transformations: [
                    {
                        "selector": "LShoe*",
                        "scale": ExpiviTransformations[sizeKey],
                        "origin": ExpiviOrigins.left,
                        "offset": {
                            "x": 0,
                            "y": 0
                        }
                    },
                    {
                        "selector": "RShoe*",
                        "scale": ExpiviTransformations[sizeKey],
                        "origin": ExpiviOrigins.right,
                        "offset": {
                            "x": 0,
                            "y": 0
                        }
                    }
                ],
            }),
            contentType: "application/json"
        }).done(function (response) {
            if (!response.status) {
                return reject();
            }

            resolve('https://okepaspoc.expivi.net/print-ready-service?hash='+response.hash);
        });
    });
}

function addToCart(createResult) {
    return new Promise(function (resolve, reject) {
        let addJsResponse = {
            quantity: 1,
            id: createResult.variant_id,
            properties: createResult.options,
        };

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify(addJsResponse),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(resolve).fail(reject);
    });
}

window.xpv_hooks_add_to_cart = function(context, event) {
    $button = $(context);
    shopifyProductId = $button.data('productId');

    // Disable button
    if ($button[0].hasAttribute('disabled')) {
        return false;
    }
    event.preventDefault();
    $button.attr('disabled', 'disabled');
    $button.addClass('loading');

    return Promise.resolve()
        .then(function() {
            return saveConfiguration();
        })
        .then(function(result) {
            return createVariant(result);
        })
        .then(function(results) {
            return fixLinkAttributes(results);
        })
        .then(function(results) {
            return getPrintReadyFile(results);
        })
        .then(function(result) {
            return addToCart(result)
        })
        .then(function() {
            if ($button.data('url') !== 'NONE') {
                window.location.href = $button.data('url');
            }

            // Don't let expivi handle add to cart
            return false;
        })
        .catch(function (error) {
            $button.removeAttr('disabled');
            $button.removeClass('loading');
            throw error;
        });
}
